export default __webpack_public_path__ + "static/media/grafema_ciceco_04.451a2761.jpg";